"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PARTY_SUB_TYPES = exports.SOLE_PROPRIETOR = exports.JOINT_VENTURE = exports.LIMITED_LIABILITY = exports.PARTNERSHIP = exports.INCORPORATED_BUSINESS = exports.UNINCORPORATED_BUSINESS = void 0;

var types_1 = require("./types"); // Business


exports.UNINCORPORATED_BUSINESS = "unincorporated_business";
exports.INCORPORATED_BUSINESS = "incorporated_business";
exports.PARTNERSHIP = "partnership";
exports.LIMITED_LIABILITY = "limited_liability";
exports.JOINT_VENTURE = "joint_venture";
exports.SOLE_PROPRIETOR = "sole_proprietor";
exports.PARTY_SUB_TYPES = _defineProperty({}, types_1.BUSINESS, [exports.UNINCORPORATED_BUSINESS, exports.INCORPORATED_BUSINESS, exports.PARTNERSHIP, exports.LIMITED_LIABILITY, exports.JOINT_VENTURE, exports.SOLE_PROPRIETOR]);